<template>
  <div class="pageWrapper_home">
    <div class="top_header">
      <div class="container">
        <Header update_profile_txt=" Update Your Profile" icon_txt="arrow_forward" />
        <div class="title_dashboard" v-if="name">
          <p>{{name}}</p>
          <!-- <div class="logout-btn"> -->
          <button class="logoutBtn" @click="logout()">{{$t('logout')}}</button>
          <!-- </div> -->
        </div>
      </div>
    </div>
    <!-- <div class="container"> -->
    <div class="middlePannel">
      <div class="leftCol_dashboard">
        <div class="heading_leftcol">
          <h2>{{$t('yourDashboard')}}</h2>
        </div>
        <div class="detail-box" @click="viewfanHistory()">
          <ul>
            <li>
              <span class="earn_badge">
                <img src="../assets/images/video-66.svg" />
                <!-- <i class="material-icons">videocam</i> -->
              </span>
              <div class="video-box">
                <p>{{$t('totalVideos')}}</p>
                <span class="amount">{{videos}}</span>
              </div>
            </li>
          </ul>
          <div class="history-btn">
            <i class="material-icons">arrow_forward</i>
            {{$t('history')}}
          </div>
        </div>
        <div class="messages" @click="aceptedRequest">
          <span class="requests">
            {{$t('acceptedMessage')}}
            ({{accepted_count}})
            <!-- ({{acceptedList.length}}) -->
            <i class="material-icons">arrow_forward</i>
          </span>
        </div>
      </div>
      <div class="rightCol_dashboard">
        <div class="heading_rightcol">
          <h2>{{$t('fansMessages')}}({{requestList.length}})</h2>
        </div>
        <div class="content">
          <!-- <span v-if="!requestList.length" class="no_data">{{$t('noDataAvailable')}}!</span> -->

          <ul>
            <li v-for="(request, index) in requestList" :key="request.request_id">
              <span class="earn1_badge">
                <img :src="request.user_profile_pic" v-if="request.user_profile_pic" />
                <img src="../assets/images/user_images.png" v-else />
              </span>
              <div class="details_dashboard">
                <span class="users-mgtext">
                  <strong>{{request.request_from}}</strong>
                  {{$t('wantsVideo')}}
                  <strong>{{request.request_for}}</strong>
                </span>
                <span class="day_time">{{request.time}}</span>
                <span class="fan_message">{{request.message}}</span>
                <!-- <span>{{request.request_id}}</span> -->
              </div>
              <div class="buttons_dashboard">
                <Btn
                  :btn_txt="$t('btnViewDetails')"
                  btn_cls="viewDetails-btn"
                  @goToFanDetailsCallback="viewFanDetails(request, request.request_id, index ) "
                />
              </div>
            </li>
          </ul>
          <infinite-loading @infinite="infiniteHandler">
            <template slot="no-more">{{ $t("NoRecordsavailable") }}</template>
          </infinite-loading>
        </div>
      </div>
    </div>
    <!-- <infinite-loading @infinite="infiniteHandler">
      <template slot="no-more">No Records available</template>
    </infinite-loading>-->
    <!-- </div> -->
    <div class="loader" v-if="loading">
      <img src="../assets/images/gif-loader.gif" />
    </div>
    <Footer />
  </div>
</template>

<script>
import VueCookie from "vue-cookie";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Btn from "../components/Btn";
import ApiCaller from "../utils/apicaller";
import types from "./../store/types";
import { toaster } from "../utils/helper";
import InfiniteLoading from "vue-infinite-loading";
import Vue from "vue";
Vue.use(InfiniteLoading);
export default {
  name: "Dashboard",
  components: {
    Footer,
    Header,
    Btn,
    InfiniteLoading
  },

  data() {
    return {
      celebrity_id: "",
      requestList: [],
      acceptedList: [],
      videos: 0,
      request_id: "",
      limit: 0,
      accepted_count: 0,
      loading: false,
      name: JSON.parse(VueCookie.get("user"))
        ? JSON.parse(VueCookie.get("user")).name
        : ""
      // data: null
    };
  },
  methods: {
    viewfanHistory() {
      this.$router.push("/fan-history");
    },

    viewFanDetails(req, details, index) {
      sessionStorage.setItem("request_detail", JSON.stringify(req));
      this.$router.push({
        path: `/fan-details/${details}`
        // query: {uploadBtn: false, index: index }
      });
    },
    infiniteHandler($state) {
      if (this.limit < 100) {
        ApiCaller(`/celebrity/available_requests/${this.limit}/10`, "get").then(
          data => {
            if (data.data.length) {
              this.limit += 10;
              this.requestList = this.requestList.concat(data.data);
              $state && $state.loaded();
            } else {
              $state && $state.complete();
            }
          }
        );
      }
    },
    totalVideos() {
      this.$store
        .dispatch({ type: "totalUploadedVideos" })
        .then(data => {
          this.videos = data.data.total_videos;
          this.accepted_count = data.data.accepted_count;
        })
        .catch(err => {
          this.loading = !this.loading;
        });
    },

    getAcceptedRequest(data) {
      return data.filter(this.checkPendingResponse);
    },

    getPendingRequest(data) {
      return data.filter(this.checkPendingRequest);
    },

    checkPendingResponse(req) {
      return req.status === "pending response";
    },

    checkPendingRequest(req) {
      return req.status === "pending request";
    },

    aceptedRequest() {
      this.$router.push({
        path: "/accepted-message"
      });
    },

    logout() {
      VueCookie.delete("user");
      this.$router.push("/");
    }
  },
  mounted() {
    this.totalVideos();
  }
};
</script>


